/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Grid } from "@mui/material";
import { PointSource } from "components/Tasks/SelectPointPanel";
import { FC } from "react";
import { NodeSelector } from "./NodeSelector";
import { IntervalSelector } from "./IntervalSelector";
import { useTranslation } from "react-i18next";

const timeRange = Array<number>(90 / 5)
  .fill(5)
  .map((n, i) => n * i + 5);

interface JobNodeInputitem {
  nodeId?: number;
  interval?: number;
}
interface JobNodeInputProps {
  label?: string;
  jobNodeInput: JobNodeInputitem;
  disabled?: boolean;
  onSelected?: (point: PointSource) => void;
}
export const JobNodeInput: FC<JobNodeInputProps> = ({
  label,
  jobNodeInput,
  disabled,
  onSelected,
}) => {
  const { t } = useTranslation();
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs={8.5}>
        <NodeSelector
          label={label}
          nodeId={jobNodeInput.nodeId}
          disabled={disabled}
          onSelected={onSelected}
        />
      </Grid>
      <Grid item xs={3}>
        <IntervalSelector
          label={t("AWVUI-MSG53")}
          timeRange={timeRange}
          interval={jobNodeInput.interval}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};
